import type { AvaApiRESTBaseQueryArgs } from '@src/providers/UserContextProvider/avaApiRESTBaseQuery';
import type {
  CreateFixedRateLoanProduct,
  CreateFloatingRateLoanProduct,
  CreateOTCForwardProduct,
  CreateOTCOptionProduct,
  CreateRepoProduct,
} from '@src/types/OTC';
import { baseRestApi } from '@src/utils/rtkQuery';
import type {
  CreateFloatingRateLoanRequest,
  CreateVanillaOptionRequest,
} from '../productDefinitions/CustomInstrumentTypes';

export type CustomInstrumentPostBody =
  | CreateFixedRateLoanProduct
  | CreateFloatingRateLoanProduct
  | CreateFloatingRateLoanRequest
  | CreateOTCOptionProduct
  | CreateVanillaOptionRequest
  | CreateOTCForwardProduct
  | CreateRepoProduct;

export type CustomInstrumentCreateResponseRow = {
  Timestamp: string;
  Symbol: string;
  Status: string;
};

const customInstrumentEndpoints = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    createCustomInstrument: builder.mutation<CustomInstrumentCreateResponseRow[], CustomInstrumentPostBody>({
      query: body =>
        ({
          method: 'POST',
          url: '/custom-instruments',
          headers: {
            'Content-Type': 'application/json',
          },
          body,
        }) satisfies AvaApiRESTBaseQueryArgs,
    }),
  }),
});

export const { useCreateCustomInstrumentMutation } = customInstrumentEndpoints;
